import React from "react";
import "./Footer.css";

const translations = {
  ar: {
    description: "أفضل تطبيق لحجز الملاعب في سوريا",
    quickLinks: "روابط سريعة",
    home: "الرئيسية",
    features: "المميزات",
    about: "من نحن",
    download: "التحميل",
    contact: "تواصل معنا",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    followUs: "تابعنا",
    rights: "جميع الحقوق محفوظة  2026 MatchUp ©",
  },
  en: {
    description: "Best stadium booking app in Syria",
    quickLinks: "Quick Links",
    home: "Home",
    features: "Features",
    about: "About",
    download: "Download",
    contact: "Contact Us",
    phone: "Phone",
    email: "Email",
    followUs: "Follow Us",
    rights: "© 2026 MatchUp. All rights reserved",
  },
};

function Footer({ language }) {
  const t = translations[language];

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/Match Up NEW.png" alt="MatchUp" />
              <span>MatchUp</span>
            </div>
            <p className="footer-description">{t.description}</p>
          </div>

          <div className="footer-section">
            <h3>{t.quickLinks}</h3>
            <ul>
              <li>
                <button onClick={() => scrollToSection("hero")} className="footer-link">{t.home}</button>
              </li>
              <li>
                <button onClick={() => scrollToSection("features")} className="footer-link">{t.features}</button>
              </li>
              <li>
                <button onClick={() => scrollToSection("about")} className="footer-link">{t.about}</button>
              </li>
              <li>
                <button onClick={() => scrollToSection("download")} className="footer-link">{t.download}</button>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>{t.contact}</h3>
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"/>
                  </svg>
                </div>
                <span>+963 996 822 151</span>
              </div>
              <div className="contact-item">
                <div className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.11,4 20,4Z"/>
                  </svg>
                </div>
                <span>info@matchup.sy</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h3>{t.followUs}</h3>
            <div className="social-links">
              <a
                href="https://www.facebook.com/share/18KyyZJYFN/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/matchup.sy?igsh=MWNsd3E4amk2c2dqNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>{t.rights}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
